import { Link } from 'react-router-dom';

const stats = [
  { value: '35+', label: 'Years of Mastery', sub: '년의 장인 경력' },
  { value: '500+', label: 'Luxury Clients', sub: '럭셔리 클라이언트' },
  { value: '100%', label: 'Handcrafted', sub: '수작업 제작' },
];

export default function AboutSection() {
  return (
    <section className="bg-[#1C1C1C] py-28 px-16">
      <div className="max-w-[1300px] mx-auto">
        {/* Top label */}
        <div className="flex items-center gap-4 mb-10">
          <div className="border border-gold/30 px-4 py-1.5">
            <span className="text-gold text-[9px] tracking-[0.25em] uppercase font-sans">
              Since 1991
            </span>
          </div>
          <div className="h-px flex-1 bg-gold/10" />
        </div>

        {/* Two-column layout */}
        <div className="grid grid-cols-2 gap-20 items-start">
          {/* Left: text */}
          <div>
            <h2 className="font-serif text-cream text-5xl font-light leading-tight mb-8 tracking-wide">
              장인의 손끝에서<br />
              <em className="text-gold not-italic">탄생하는 예술</em>
            </h2>
            <p className="text-cream/50 text-sm leading-8 font-sans font-light mb-8">
              하이반텍스는 전통 불리온 기법과 현대적 감각을 결합하여
              최고의 자수 작품을 선사합니다. 35년 이상의 장인 정신으로
              전 세계 럭셔리 브랜드와 함께하며, 한 땀 한 땀의 정성으로
              귀사의 브랜드 아이덴티티를 완성합니다.
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-3 border border-cream/20 text-cream/60 text-[10px] tracking-[0.22em] uppercase px-8 py-3 hover:border-gold/60 hover:text-gold transition-all duration-300 font-sans whitespace-nowrap cursor-pointer"
            >
              Our Story
              <i className="ri-arrow-right-line text-xs" />
            </Link>
          </div>

          {/* Right: stats */}
          <div className="space-y-0 divide-y divide-cream/5">
            {stats.map((s) => (
              <div key={s.value} className="py-8 flex items-center justify-between">
                <div>
                  <p className="text-cream/30 text-xs tracking-[0.15em] uppercase font-sans mb-1">
                    {s.label}
                  </p>
                  <p className="text-cream/50 text-xs font-sans font-light">
                    {s.sub}
                  </p>
                </div>
                <span className="font-serif text-gold text-5xl font-light">
                  {s.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
